import React from 'react'
import { useNavigate } from 'react-router-dom';
import './Hubnav.css'
const Hubnav = () => {
    var nav=useNavigate()
    function navigateProfile(){
        nav('/Profile')
      }
      function navigateHub(){
        nav('/DistributionHubPanel')
      }
  return (
    <>
    <div className='row navi gx-0 my-2'>
    <div className='col-lg-2 col-md-2 usernav'>
    <img src='https://res.cloudinary.com/vcart/image/upload/v1653901249/Screenshot__131_-removebg-preview_v1bpdc.png' style={{height:"30px", marginTop:"3px"}} alt="VCART" onClick={()=>navigateHub()} />
    </div>
    <div className='col-lg-2  col-md-2 HubIcons my-auto'>
    <a onClick={()=>navigateHub()}><i className="fas fa-warehouse mx-3"></i></a> 
    <a onClick={()=>navigateProfile()}><i className="fas fa-user-circle mx-3"></i></a>
    </div>
    </div>
    </>
  )
}

export default Hubnav